// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"260d053c","593":"d0c9dbfa","955":"13e096bb"}[chunkId] + ".chunk.js";
};